<template>
  <Input
    v-model:value.trim="checkCode"
    class="custom"
    :placeholder="$lang('验证码')"
    size="large"
    allow-clear
    :maxlength="6"
    :minlength="6"
  >
    <template #addonAfter>
      <Button type="link" danger :disabled="!canSend" v-if="!sendFlag" size="small" @click="showVerify">{{
        $lang('发送')
      }}</Button>
      <Button type="link" danger :disabled="!canSend" v-else-if="count === 0" size="small" @click="showVerify">
        {{ $lang('重新发送') }}</Button
      >
      <Button type="link" danger v-else size="small"> {{ count }}{{ $lang('秒') }}</Button>
    </template>
  </Input>
  <Verify
    mode="pop"
    captchaType="blockPuzzle"
    :imgSize="{ width: '400px', height: '200px' }"
    ref="verify"
    @success="success"
  ></Verify>
</template>
<script lang="ts" setup name="VerifyInput">
  import { computed, ref, watch } from 'vue'
  import { MOBILE_REG } from '@/utils/validator'
  import useTimer from '@/hooks/useTimer'
  import { useApi, Verify } from '@xinghai/site-common'
  import { Input, message, Button } from 'ant-design-vue'
  import { lang } from '@/utils'

  interface Iprops {
    mobile: string
    value: string
    api: any
  }
  const props = defineProps<Iprops>()
  const emit = defineEmits(['update:value'])

  /**滑块数据 */
  const captchaVerification = ref('')
  const verify = ref<InstanceType<typeof Verify>>()
  const checkCode = ref(props.value)
  /**发送点击标识 */
  const canSend = computed(() => MOBILE_REG.test(props.mobile))
  const { begin, count, sendFlag } = useTimer()
  const timeVal = ref(60)

  let sendMsgApi = useApi<any>(props.api) as Record<string, any>
  watch(
    () => props.api,
    (cal) => {
      sendMsgApi = useApi<any>(cal) as Record<string, any>
    }
  )
  const showVerify = () => {
    if (sendMsgApi.loading.value) return
    verify.value?.show()
  }
  const success = async (e: { captchaVerification: string }) => {
    captchaVerification.value = e.captchaVerification
    sendMsgApi.fetchData({ mobile: props.mobile, captchaVerification: captchaVerification.value }).then(() => {
      message.success(lang('短信发送成功'))
      begin(timeVal.value)
    })
  }

  watch(
    () => checkCode.value,
    (value) => {
      emit('update:value', value)
    }
  )
  const stopCount = () => {
    sendFlag.value = false
  }
  const change = () => {
    checkCode.value = ''
  }
  defineExpose({ stopCount, change })
</script>
